import React, { useEffect, useState, useRef } from 'react'
import AppLayout from '@/Layouts/AppLayout'
import { Container } from '@/Components'
import "react-datepicker/dist/react-datepicker.css";
import { ExpandableBlockQuestion } from "@/Components/Questions/ExpandableBlockQuestion";
import { usePage } from "@inertiajs/inertia-react";

import { Dropdown } from '@/Components';
import { Select } from '@/Components/Form';
import { Inertia } from '@inertiajs/inertia';

export default function EmissionsReporter({ questions }) {

  const teams = usePage().props?.teams?.data || [];
  // const questions = usePage().props?.questions || [];
  const initialLoad = useRef(true);

  const [filter, setFilter] = useState({
    team: '',
    sort: 'name',
  });

  const sortOptions = [
    {value: 'name', label: 'Name'},
    {value: 'team', label: 'Team'},
    {value: 'created_at', label: 'Created at'},
    {value: 'updated_at', label: 'Updated at'},
  ];
  const teamOptions = [
    {value: '', label: 'All teams'},
    ...teams.map(team => ({
      value: team.id,
      label: team.name
    }))
  ];

  useEffect(() => {
    if (initialLoad.current === true) {
      initialLoad.current = false;
      return;
    }
    Inertia.put(route('reporter.overview.post'), {filters: filter}, {
      preserveState: true,
      preserveScroll: true,
      onSuccess: (page) => {
        // console.log('success', page);
      },
    });
  }, [filter]);

  const changeFilter = (type, value) => {
    setFilter({
      ...filter,
      [type]: value
    });
  }

  return (
    <>
      <Container size={"4xl:max-w-screen-3xl"} padding={"px-4 lg:px-16 4xl:pl-32"} className="4xl:mx-0 mt-4 sm:dots-orange">
        <div className="flex flex-col gap-4 p-4">
          <h2 className="text-5xl font-bold">Reporting</h2>
          <p>Here you can see all tasks that need to be reported on.</p>

          <div className="flex flex-row items-center justify-between gap-4">
            <div className="w-1/3 min-w-32">
              {teamOptions.length > 2 &&
                <Select options={teamOptions} noDefault={true} onChange={(e) => { changeFilter('team', e.target.value) }} />
              }
            </div>
            <div className="">
              <Dropdown options={sortOptions} title="Sort on" placeholder="Name" onSelect={(id) => changeFilter('sort', id)} />
            </div>
          </div>

          <div>
          {questions.data.map(question => {
            return <ExpandableBlockQuestion key={`question_${question.id}_${question.pivot.team_id}`} derivedTeam={teams.find(t => t.id === question.pivot.team_id)} showTeam={true} question={question} />
          })}
          </div>

        </div>

      </Container>
    </>
  )
}


EmissionsReporter.layout = page => (
  <AppLayout title="Emission Accounting">{page}</AppLayout>
)
